import ConfigGeneral from '../config/general';

/* eslint-disable import/no-anonymous-default-export */
export default {
	components: {
		map: {
			mapLayer: 'Térképréteg',
		},
		mapFilter: {
			searchPrimary: 'Keresés',
			searchSecondary: 'Település vagy helyszín nevére',
			searchPlaceholder: 'Írd ide a keresett kifejezést',
			filterPrimary: 'Helyszíntípus',
			filterSecondary: 'Szűrés kategóriák alapján',
			dataPrimary: 'Rendelkezésre álló adatok',
			dataSecondary: 'Szűrés az elérhető információkra',
		},
		mapLegend: {
			title: 'Jelmagyarázat',
			seaLevel: 'Tengerszint',
			belowSeaLevel: 'Tengerszint alatt',
			elevation100: '100 m szintemelkedés',
			elevation50: '50 m szintemelkedés',
			broadLeavedForest: 'Lomblevelű erdő',
			coniferousForest: 'Tűlevelű erdő',
			mixedForest: 'Elegyes erdő',
			naturalGrasslands: 'Füves terület',
			moorsAndHeathland: 'Fenyér',
			sclerophyllousVegetation: 'Keménylombú növényzet',
			transitionalWoodlandShrub: 'Cserjés erdőszegély',
			beachesDunesSands: 'Homok',
			inlandMarshes: 'Láp',
			peatBogs: 'Tőzegláp',
			saltMarshes: 'Szikes mocsár',
			intertidalFlats: 'Árapály-zóna',
			motorway: 'Autópálya',
			mainRoad: 'Főút',
			railway: 'Vasút',
			administrativeBoundary: 'Közigazgatási határ',
			lakeAndWaterTank: 'Tó és víztározó',
			forest: 'Erdő',
			natureReserve: 'Természetvédelmi terület',
			grasslandAndMeadow: 'Füves terület és rét',
			pedestrianZone: 'Gyalogos övezet',
			commericalArea: 'Kereskedelmi terület',
			industrialArea: 'Ipari terület',
		},
		placePopup: {
			imagesAvailable: 'kép érhető el',
			videosAvailable: 'videó érhető el',
			details: 'Részletek',
		},
		placeDetails: {
			overview: 'Áttekintés',
			guide: 'Ismertető',
			reconstruction: 'Rekonstrukció',
			media: 'Média',
			placeType: 'Helyszíntípus',
			altNames: 'További megnevezések',
			location: 'Település',
			coordinates: 'Koordináták',
			openInNewWindow: 'Megnyitás új ablakban',
		},
	},
	app: {
		loadingError: 'Hiba az adatok betöltése közben',
		impressum: 'Impresszum',
		close: 'Bezár',
	},
	global: {
		yes: 'Igen',
		no: 'Nem',
		photo: 'Képek',
		panoramaPhoto: 'Panorámaképek',
		video: 'Videó',
		guide: 'Ismertető',
		loading: 'Betöltés'
	},
	fancybox: {
		AJAX_FORBIDDEN: "Hiba a betöltés közben",
		AJAX_NOT_FOUND: "Hiba a betöltés közben",
		CLOSE: "Bezár",
		DOWNLOAD: "Letöltés",
		ELEMENT_NOT_FOUND: "Hiba a betöltés közben",
		ERROR: "Hiba a betöltés közben",
		IFRAME_ERROR: "Hiba a betöltés közben",
		IMAGE_ERROR: "Hiba a betöltés közben",
		MODAL: "Az ablak bezárható az ESC gombbal",
		NEXT: "Következő",
		PREV: "Előző",
		TOGGLE_FULLSCREEN: "Teljes képernyő",
		TOGGLE_SLIDESHOW: "Diavetítés",
		TOGGLE_THUMBS: "Bélyegképek",
		TOGGLE_ZOOM: "Nagyítás",
	},
	filters: {
		state: {
			label: 'Állapot',
			all: 'Mind',
			active: 'Aktív',
			inactive: 'Inaktív',
		},
	},
	resources: {
		placetypes: {
			name: 'Helyszín típusok',
			fields: {
				id: '#',
				name: 'Név',
				name_display: 'Név',
				state: 'Aktív',
				ordering: 'Rendezés',
				icon: 'Ikon (SVG)'
			}
		},
		phototypes: {
			name: 'Kép típusok',
			fields: {
				id: '#',
				name: 'Név',
				name_display: 'Név',
				state: 'Aktív',
				ordering: 'Rendezés',
			}
		},
		modeltypes: {
			name: '3D modell típusok',
			fields: {
				id: '#',
				name: 'Név',
				name_display: 'Név',
				state: 'Aktív',
				ordering: 'Rendezés',
			}
		},
		users: {
			name: 'Felhasználók',
			fields: {
				id: '#',
				name: 'Név',
				email: 'Email cím',
				password: 'Jelszó',
			}
		},
		places: {
			name: 'Helyszínek',
			fields: {
				id: '#',
				name: 'Megnevezés',
				name_display: 'Megnevezés',
				alt_name: 'Alternatív megnevezés',
				location: 'Település',
				location_display: 'Település',
				guide_intro: 'Rövid leírás',
				guide: 'Ismertető',
				place_type_ids: 'Típus',
				coordinate_x: 'Hosszúsági fok',
				coordinate_y: 'Szélességi fok',
				state: 'Aktív',
				ordering: 'Rendezés',
				source: 'Szolgáltató',
				video_id: 'Videó ID',
				caption: 'Cím',
				reconstruction: 'Rekonstrukció',
				model_type_id: 'Típus',
				preview: 'Előnézeti képfájl',
				model: 'Modellfájl',
				models: '',
				videos: '',
				previewInput: 'Húzd ide az előnézeti képfájlt, vagy kattints a kiválasztáshoz',
				modelInput: 'Húzd ide a modellfájlt, vagy kattints a kiválasztáshoz',
			},
			tab: {
				summary: 'Általános',
				photos: 'Képek',
				videos: 'Videók',
				models: '3D modellek',
			},
		},
		settings: {
			name: 'Beállítások',
			fields: {
				page_title: 'Fejléc szövege',
				sidebar_title: 'Oldalsáv címe',
				sidebar_text: 'Oldalsáv bevezető szövege',
				footer_text: 'Lábléc szövege',
				impressum: 'Impresszum tartalma',
			}
		},
	},
	ra: {
		action: {
			add_filter: 'Szűrés',
			add: 'Hozzáadás',
			back: 'Vissza',
			bulk_actions: '%{smart_count} kiválasztva',
			cancel: 'Mégsem',
			clear_input_value: 'Törlés',
			clone: 'Másolás',
			create: 'Új',
			delete: 'Törlés',
			edit: 'Szerkesztés',
			export: 'Exportálás',
			list: 'Listához',
			refresh: 'Frissít',
			remove_filter: 'Szűrő törlése',
			remove: 'Törlés',
			save: 'Mentés',
			save_and_list: 'Mentés és vissza',
			save_and_add: 'Mentés és új',
			show: 'Megtekint',
			sort: 'Rendezés az oszlop szerint',
			undo: 'Visszavonás',
			bulk_disable_state: 'Letiltás',
			bulk_enable_state: 'Engedélyezés',
			change_ordering: 'Sorrend módosítása',
			unselect: 'Kijelölés törlése',
			confirm: 'Megerősítés',
			search: 'Keresés',
		},
		locales: ConfigGeneral.locales.reduce((obj, item) => {
			return {
				...obj,
				[item.code]: item.name,
			};
		}, {}),
		boolean: {
			true: 'Igen',
			false: 'Nem',
		},
		state: {
			active: 'Engedélyezve',
			inactive: 'Letiltva',
		},
		page: {
			create: '%{name} létrehozása',
			dashboard: 'Irányítópult',
			edit: '%{name} #%{id}',
			error: 'Hiba történt',
			list: '%{name} lista',
			loading: 'Betöltés',
			not_found: 'Nem található',
			show: '%{name} #%{id}',
			empty: 'Nincsenek elemek',
			invite: 'Hozz létre egyet az alábbi gombbal.',
		},
		input: {
			file: {
				upload_several: 'Húzd ide a fájlokat, vagy kattints a kiválasztáshoz.',
				upload_single: 'Húzz ide egy fájlt, vagy kattints a kiválasztáshoz.',
			},
			image: {
				upload_several: 'Húzd ide a képeket, vagy kattints a kiválasztáshoz.',
				upload_single: 'Húzz ide egy képet, vagy kattints a kiválasztáshoz.',
			},
			references: {
				all_missing: 'A referencia adatok nem elérhetőek',
				many_missing: 'Egy vagy több referencia adat nem elérhető',
				single_missing: 'Egy referencia adat nem elérhető',
			},
		},
		message: {
			about: 'Névjegy',
			are_you_sure: 'Biztos vagy benne?',
			bulk_delete_content: 'Biztos törlöd? |||| Biztosan törölsz %{smart_count} elemet?',
			bulk_delete_title: 'Elem törlése |||| %{smart_count} elem törlése',
			delete_content: 'Biztosan törlöd?',
			delete_title: '#%{id} törlése',
			details: 'Részletek',
			error: 'Kliens hiba a kérés közben',
			invalid_form: 'Az űrlap kitöltése helytelen. Ellenőrizd a hibákat!',
			loading: 'Betöltés',
			no: 'Nem',
			not_found: 'A keresett oldal nem található.',
			yes: 'Igen',
			bulk_disable_state: 'Biztosan letiltod az elemet? |||| Biztosan letiltasz %{smart_count} elemet?',
			bulk_enable_state: 'Biztosan engedélyezed az elemet? |||| Biztosan engedélyezel %{smart_count} elemet?',
		},
		navigation: {
			no_results: 'Nincs találat.',
			no_more_results: 'Nincs több találat.',
			page_out_of_boundaries: '%{page}. oldal nem létezik',
			page_out_from_end: 'Az utolsó oldalnál tovább nem lehet lapozni',
			page_out_from_begin: 'Az első oldalnál előrébb nem lehet lapozni',
			page_range_info: '%{offsetBegin}-%{offsetEnd}, összesen %{total}',
			next: 'Következő',
			prev: 'Előző',
			page_rows_per_page: 'Egy lapon:',
			skip_nav: 'Skip to content',
		},
		auth: {
			username: 'Felhasználónév',
			password: 'Jelszó',
			sign_in: 'Bejelentkezés',
			sign_in_error: 'Sikertelen bejelentkezés.',
			logout: 'Kijelentkezés',
			user_menu: 'Felhasználó',
		},
		notification: {
			updated: 'Módosítások mentve |||| %{smart_count} elem szerkesztve',
			created: 'Az elem létrehozva',
			deleted: 'Az elem törölve |||| %{smart_count} elem törölve',
			bad_item: 'Incorrect element',
			item_doesnt_exist: 'Az elem nem létezik',
			http_error: 'Hiba történt a kommunikáció során',
			data_provider_error: 'Adatszolgáltatói hiba',
			canceled: 'Művelet megszakítva',
			state_updated: 'Az állapot frissítve',
			bulk_disable_state: 'Az elem letiltva |||| %{smart_count} elem letiltva',
			bulk_enable_state: 'Az elem engedélyezve |||| %{smart_count} elem engedélyezve',
			ordering_updated: 'Sorrend frissítve',
		},
		validation: {
			required: 'Kötelező kitölteni',
			minLength: 'Minimum %{min} karakter',
			maxLength: 'Maximum %{max} karakter',
			minValue: 'Legalább %{min}',
			maxValue: 'Legfeljebb %{max}',
			number: 'Kizárólag szám lehet',
			email: 'Helytelen formátum',
			oneOf: 'Egy a következőkből: %{options}',
			regex: 'Egyeznie kell a következő formátummal (regexp): %{pattern}',
		},
		fileManager: {
			behaviourAlert: 'A módosítások - beleértve a fájlok feltöltését - a mentés gomb megnyomását követően lépnek életbe.',
			info: 'Húzd a fájlokat az alábbi területre, vagy kattints a fájlok hozzáadása gombra. A sorrend áthúzással módosítható.',
			selectFiles: 'Fájlok hozzáadása',
			dragOverText: 'Ejtsd ide a fájlokat',
			caption: 'Cím',
			deleteConfirm: {
				title: 'Biztos törölni szeretnéd a fájlt?',
				uploadedInfo: 'A fájl már fel van töltve a szerverre, a mentés gomb megnyomását követően fogjuk törölni.',
				notUploadedInfo: 'A fájl még nincs feltöltve a szerverre, eltávolítjuk a listából.',
				delete: 'Törlés',
				cancel: 'Mégse',
			}
		}
	},
};